import {flattenMessages} from "../util/IntlUtils";
import messages from "../constants/locale/en-CA";

export default {
    events: {
        error: null,
        items: [],
        meta: {
            loaded: false,
            fetching: false
        }
    },
    intl: {
        locale: 'en-CA',
        messages: flattenMessages(messages)
    },
    polish: {
        error: null,
        items: [],
        meta: {
            loaded: false,
            fetching: false
        }
    },
    rooms: {
        error: null,
        items: [],
        list: [],
        meta: {
            loaded: false,
            fetching: false
        }
    },
    snackbars: {
        items: []
    },
    users: {
        meta: {
            submitting: false
        }
    },
    weather: {
        data: {
            list: []
        },
        meta: {
            loaded: false,
            fetching: false
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/initialState.js